import './QuickButtons.css';

const CARD_COLORS = [
  '#4A90E2', '#F5A623', '#7ED321',
  '#D0021B', '#9013FE', '#50E3C2',
];

const QuickButtons = ({ onButtonClick, cards = [] }) => {
  if (!cards.length) return null;

  return (
    <div className="quick-buttons-container">
      <div className="quick-buttons-header">
        <h3 className="quick-buttons-title">
          <span className="title-icon">💡</span>
          Quick Questions
        </h3>
        <p className="quick-buttons-subtitle">Tap any button to get started</p>
      </div>

      <div className="quick-buttons-grid">
        {cards.map((card, idx) => (
          <button
            key={idx}
            className="quick-button"
            onClick={() => onButtonClick(card.card_question)}
            style={{ '--button-color': CARD_COLORS[idx % CARD_COLORS.length] }}
          >
            <span className="quick-button-icon">{card.card_icon}</span>
            <span className="quick-button-label">{card.card_label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickButtons;
